import { globalRef } from '@amazon/vinyl-util'

export interface PerformanceBudget {
    readonly maxPixelRatio: number
    readonly prefetch: boolean
}

// Seeded at boot from the device's performance profile; util cannot import `@/device` (it depends on util).
const budgetRef = globalRef<{ value: PerformanceBudget }>(() => ({
    value: { maxPixelRatio: 2, prefetch: true },
}))

export function performanceBudget(): PerformanceBudget {
    return budgetRef.value.value
}

export function setPerformanceBudget(budget: PerformanceBudget): void {
    budgetRef.value.value = budget
}
